import React, {useCallback} from 'react';

import {observer} from 'mobx-react';

import {accessGroupEnum} from '../../../serverClientShared/sharedEnums';
import ConditionalComponent from '../../Shared/ConditionalComponent';
import PrivacyToggle from './PrivacyToggle';
import {PublicBanner, PrivateBanner} from './PrivacyBanners';
import InvitedMembersRow from './InvitedMembersRow';
import PpcAccessBanner from './PpcAccessBanner';
import usePrivacySection from './usePrivacySection';

const hasGuestAccess = (sources) => (sources || []).includes(accessGroupEnum.GUEST);

const PrivacySection = observer(({settings, privateCopy}) => {
    const {addRef, handleOpenShare, isAccessLoaded} = usePrivacySection(settings);

    const handleTogglePublic = useCallback((isPublic) => {
        settings.setEditedIsPublic(isPublic);
        if (isPublic) settings.setEditedAccessSources([...settings.originalAccessSources]);
    }, [settings]);

    const handleRemoveInvited = useCallback((id) => {
        settings.setEditedAccessSources(settings.editedAccessSources.filter((s) => s !== id));
        settings.setAccessGroups(settings.accessGroups.filter((g) => g.GroupId !== id));
        settings.setAccessMembers(settings.accessMembers.filter((m) => m._id !== id));
    }, [settings]);

    if (settings.editedIsPublic === null) return null;

    if (hasGuestAccess(settings.originalAccessSources)) return <PpcAccessBanner />;

    return (
        <div>
            <PrivacyToggle isPublic={settings.editedIsPublic} onToggle={handleTogglePublic} />
            <ConditionalComponent if={settings.editedIsPublic}><PublicBanner copy={privateCopy?.publicBanner} /></ConditionalComponent>
            <ConditionalComponent if={!settings.editedIsPublic}>
                <PrivateBanner copy={privateCopy?.privateBanner} />
                <InvitedMembersRow groups={settings.accessGroups} members={settings.accessMembers} addRef={addRef} onAdd={handleOpenShare} onRemove={handleRemoveInvited} isAccessLoaded={isAccessLoaded} />
            </ConditionalComponent>
        </div>
    );
});

export default PrivacySection;
